import React from "react";

import './index.less';

export const PartContent = props => {
  return (
    <div className="row align-items-center">{props.children}</div>
  );
};
